import React, { useState } from 'react';
import { PractitionerPicker } from '../../CustomControls/PractitionerPicker';
import { Button, Col, ControlLabel, FormGroup, Grid, Modal, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { CustomSelect } from '../../CustomControls/CustomSelect';
import { Add, Save } from '../../Icons/Icons';
import { ModalData } from '../../Modals/ModalData';
import { CustomSearchBox } from '../../CustomControls/CustomSearchBox';

const PractitionerForm = ({ props, deleteAllPractitionersButton, AddPractitionersButton }) => {
    const { t } = useTranslation();
    const [isShowing, setIsShowing] = useState(false);

    const {
        dataPractitioner,
        queryPractitioner,
        totalSizePractitioner,
        isPractitionerLoading,
        addPractitioners,
        removePractitioner,
        handleTableChangePractitioner,
        addPractitioners_Handler,
        deletePractitioner_Handler,
        selectedPatient,
        confirmPractitioner,
        handleFilterChangePractitioner,
        deleteAllPractitioners_Handler
    } = props


    return (
        <>
            <div className="row">
                {AddPractitionersButton}

                <div className="col-md-5">
                    <CustomSearchBox handleSearch={(value) => handleFilterChangePractitioner("userName", value)} placeholder={t('users.search')}></CustomSearchBox>
                </div>

                {deleteAllPractitionersButton}
            </div>
            <ModalData
                isShowing={isShowing}
                hide={() => setIsShowing(false)}
                title={t('protocols.groups.addPractitioner')}
                size="medium"
                className=""
                footer={
                    <>
                        <Button type="button" className="btn " onClick={() => setIsShowing(false)} >{t("buttons.cancel")}</Button>
                        <Button type="submit" className="btn btn-success btn-primary" onClick={confirmPractitioner}>
                            <Save />{t("buttons.save")}
                        </Button>
                    </>  
                }
            >
                <div>
                    <FormGroup>
                        <ControlLabel>{t('protocols.brief.practitioner')}</ControlLabel>
                            <PractitionerPicker
                                id="practitioner"
                                name="practitioner"
                                autoFocus
                                multiple={true}
                                onlyDoctor={true}
                                excludeMonitors={true}
                                placeholder={t('protocols.brief.practitioner')}
                                onChange={addPractitioners_Handler}
                            />
                    </FormGroup>
                </div>
                
            </ModalData>
        </>
    );
};

export default PractitionerForm;